import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-scheme',
	path: '/jira/settings/issues/field-schemes/:schemeId',
	exact: true,
};
